import {Injectable} from '@angular/core';
import {Observable, ReplaySubject, throwError} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Router} from '@angular/router';
import {RolePermissionView, UserView} from './model/user';
import {catchError, tap} from 'rxjs/operators';
import {environment} from "../environments/environment";


@Injectable()
export class AuthenticationService {

    _roles = new ReplaySubject<string[]>(1);

    _modules = new ReplaySubject<string[]>(1);

    _user = new ReplaySubject<UserView>(1);

    _permissions = new ReplaySubject<RolePermissionView[]>(1);

    constructor(private http: HttpClient,
                private router: Router) {
        this._user.subscribe(user => {
            if (!!user) {
                this.http.get<string[]>(`${environment.apiRoot}/auth/roles`)
                    .subscribe(roles => this._roles.next(roles));
                this.http.get<string[]>(`${environment.apiRoot}/auth/modules`)
                    .subscribe(modules => this._modules.next(modules));
                this.http.get<RolePermissionView[]>(`${environment.apiRoot}/auth/permissions`)
                    .subscribe(permissions => this._permissions.next(permissions));
            }
        });
        this.http.get<UserView>(`${environment.apiRoot}/auth`)
            .subscribe(user => this._user.next(user))
    }

    permissions(): Observable<RolePermissionView[]> {
        return this._permissions.asObservable();
    }

    roles(): Observable<string[]> {
        return this._roles.asObservable();
    }

    modules(): Observable<string[]> {
        return this._modules.asObservable();
    }

    logout(prevUrl: string = null) {
        const queryParams = {};
        if (prevUrl)
            queryParams['goto'] = prevUrl;
        this.http.post(`${environment.apiRoot}/logout`, {}).subscribe(
            () => {
            },
            () => {
            },
            () => {
                this._roles.next(null);
                this._modules.next(null);
                this._permissions.next(null);
                this._user.next(null);
                this.router.navigate(['/login'], {queryParams: queryParams}).then();
            }
        );
    }

    userNoCache(): Observable<UserView> {
        return this.fetchUser(new HttpHeaders(), null);
    }

    user(): Observable<UserView> {
        return this._user.asObservable();
    }

    login(username: string, password: string, onError: (errorResponse) => void): Observable<UserView> {
        const hash = btoa(`${username}:${password}`);
        return this.fetchUser(new HttpHeaders().append('Authorization', `Basic ${hash}`), onError);
    }

    private fetchUser(headers: HttpHeaders, onError: (errorResponse) => void): Observable<UserView> {
        return this.http
            .get<UserView>(`${environment.apiRoot}/auth`, {
                withCredentials: true,
                headers: headers
            })
            .pipe(
                catchError(e => {
                    if (onError)
                        onError(e);
                    return throwError(e);
                }),
                tap(user => this._user.next(user))
            );
    }

}
